export interface AutosuggestItem {
    value: string;
    description: string;
    image?: string;
    label?: string;
}
